import { render } from "./ReviewChoiceStep.vue?vue&type=template&id=415169c4&scoped=true"
import script from "./ReviewChoiceStep.vue?vue&type=script&lang=js"
export * from "./ReviewChoiceStep.vue?vue&type=script&lang=js"

import "./ReviewChoiceStep.vue?vue&type=style&index=0&id=415169c4&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415169c4"]])

export default __exports__